<template>
  <div class="width-100 mainBox flex-column justify-content-start align-items-center" style="min-width: 1200px">
    <!--    顶部菜单栏-->
    <tab class="fixed" selectTab="7" style="min-width: 1200px"></tab>
    <div class="width-100 flex-column align-items-star justify-content-start" style="max-width: 960px">
      <div class="flex-row align-items-baseline justify-content-start margin-t width-100">
        <div class="fw-mid fs-big margin-r">填写留言</div>
        <span style="color: #ff4949" class="fs-mid">*为必填项</span>
      </div>
      <div class="width-80 margin-t">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm width-100">
          <el-form-item label="姓名" prop="mailName" :rules="[{ required: true, message: '请输入姓名' }]">
            <el-input v-model="ruleForm.mailName" style="width: 30rem"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="mailPhone" :rules="[{ required: true, message: '请输入联系电话' }]">
            <el-input v-model="ruleForm.mailPhone" style="width: 30rem"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱">
            <el-input v-model="ruleForm.email" style="width: 30rem"></el-input>
          </el-form-item>
          <el-form-item label="单位名称" prop="deptName" :rules="[{ required: true, message: '请输入单位名称' }]">
            <el-input v-model="ruleForm.deptName" style="width: 30rem"></el-input>
          </el-form-item>
          <el-form-item label="标题" prop="title" :rules="[{ required: true, message: '请输入标题' }]">
            <el-input v-model="ruleForm.title" style="width: 30rem"></el-input>
          </el-form-item>
          <el-form-item label="内容" prop="content" :rules="[{ required: true, message: '请输入内容' }]">
            <textarea
              placeholder="最多600字"
              v-model="ruleForm.content"
              style="
                width: calc(30rem - 30px);
                padding: 15px;
                border: 1px solid #dcdfe6;
                height: 10rem;
                line-height: 1.2rem;
                resize: none;
                outline: none;
                border-radius: 0.25rem;
              "
            ></textarea>
          </el-form-item>
          <el-form-item label="上传凭证" prop="files" :rules="[{ required: true, message: '请输入上传凭证' }]">
            <file-upload v-model="ruleForm.files" :fileType="['doc', 'xls', 'ppt', 'txt', 'pdf', 'jpg', 'png']"></file-upload>
            <!--            <el-upload class="upload-demo" drag action="https://jsonplaceholder.typicode.com/posts/" multiple style="width: 30rem">-->
            <!--              <i class="el-icon-upload"></i>-->
            <!--              <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>-->
            <!--            </el-upload>-->
          </el-form-item>
          <el-form-item>
            <div style="width: 30rem" class="flex-row align-items-center justify-content-center">
              <el-button @click="reset" style="width: 6rem" class="margin-r">重填</el-button>
              <el-button @click="submit" type="primary" style="background: #0b499e; width: 6rem" class="submit-button margin-l">提交</el-button>
            </div>
          </el-form-item>
        </el-form>
        <div class="width-100 flex-row align-items-center justify-content-spaceBetween">
          <div style="width: 100px" class="margin-rs"></div>
          <div class="width-100 flex-column align-items-center justify-content-center margin-t margin-b">
            <div class="width-100 fs-big" style="color: #0b499e">其他方式：</div>
            <div class="width-100" style="font-size: 16px; line-height: 26px">信件邮寄地址：浙江省瑞安市安阳街道阳光路155号国投大厦纪检审计部</div>
            <div class="width-100" style="font-size: 16px; line-height: 26px">举报电话：0577-65827625</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tab from '@/components/tab.vue';
import config from '@/config';
import 'vue-okr-tree/lib/vue-okr-tree.css';
import FileUpload from '@/components/fileUpload';
import mailApi from '@/api/mailApi';
export default {
  name: 'submit',
  components: {
    FileUpload,
    tab
  },
  data() {
    return {
      fzlc: require('@/assets/image/fzlc.png'),
      imagePrefix: config.IMAGE_PREFIX,
      fileList: [],
      ruleForm: {
        mailName: null,
        mailPhone: null,
        email: null,
        deptName: null,
        title: null,
        content: null,
        files: null
      },
      rules: {}
    };
  },
  created() {},
  methods: {
    reset() {
      this.ruleForm = {
        mailName: null,
        mailPhone: null,
        email: null,
        deptName: null,
        title: null,
        content: null,
        files: null
      };
    },
    submit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          mailApi.sendMail(this.ruleForm).then((res) => {
            console.log(res);
            if (res.code === 200) {
              this.$message({
                message: '提交成功',
                type: 'success'
              });
              this.reset();
            } else {
              this.$message({
                message: '网络异常请稍后再试',
                type: 'warning'
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    select(e) {
      this.tabIndex = e;
    },
    jumpTo(e, m) {
      this.$router.push({ path: e, params: { Id: m } });
    }
  }
};
</script>

<style lang="less" scoped>
.fixed {
  position: fixed;
  top: 0;
  z-index: 99;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}
.mainBox {
  height: 200px;
  padding-top: 60px;
}
.search {
  border: none !important;
}
.searchBox {
  padding: 4px 10px;
  border-radius: 5px;
}
.tab {
  height: 50px;
  width: 100%;
  border-bottom: 1px solid #eeeeee;
}
.tab_avtive {
  background: rgb(11, 73, 158) !important;
  border-left: 6px solid rgb(204, 58, 58);
  color: white;
  border-bottom: none;
}
.border-b {
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 20px;
}
.box {
  height: 140px;
}
.leftBox {
  width: 17%;
  margin-right: 3%;
}
</style>
<style>
.van-pagination__item--active {
  background-color: rgb(11, 73, 158) !important;
  color: #ffffff !important;
}
.van-pagination__item {
  min-width: 30px;
  height: 30px;
  margin: 0 3px;
  border: 1px solid #eeeeee;
  color: #666666;
}
.el-step__main {
  padding-bottom: 40px;
}
.el-step__title {
  font-weight: bold;
}
.el-step__description {
  font-size: 1rem;
  line-height: 1.5rem;
  margin-top: 0px;
}
.el-step__title.is-finish,
.el-step__description.is-finish {
  color: #333333;
}
.el-step__icon-inner.el-icon-s-help {
  color: rgb(11, 73, 158);
}
.el-step__line-inner {
  border-color: rgb(11, 73, 158);
}
.el-step__head {
  margin-right: 20px;
}
.align-items-baseline {
  align-items: baseline;
}
.el-upload-dragger {
  width: 30rem;
  border: 0.0625rem solid #d9d9d9;
}
.submit-button span {
  color: #ffffff;
}
</style>
